import { useAuth } from "@/auth/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GeneralSettingsSection } from "@/components/settings/GeneralSettingsSection";
import { PayablesSettingsSection } from "@/components/settings/PayablesSettingsSection";
import { SpendCategoriesSection } from "@/components/settings/SpendCategoriesSection";
import { ReceivablesSettingsSection } from "@/components/settings/ReceivablesSettingsSection";
import { ExpensesSettingsSection } from "@/components/settings/ExpensesSettingsSection";
import { WhatsAppSettingsSection, useWhatsAppConnection } from "@/components/settings/WhatsAppSettingsSection";

/** Client settings tabs, each backed by its own endpoint (/client, /settings/ap, /settings/ar, /settings/expenses, /whatsapp/connection). */
export function SettingsPage() {
  const { activeClient, activeClientId } = useAuth();
  const isAdmin = activeClient?.role === "Owner" || activeClient?.role === "Admin";
  const whatsApp = useWhatsAppConnection();
  // Hidden until the read settles, so a Client without the module never sees the tab flash in.
  const showWhatsApp = !whatsApp.loading && !whatsApp.notEntitled;

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-6 px-6 py-8">
      <div>
        <h1 className="text-3xl font-bold">Settings</h1>
        <p className="mt-1 text-sm text-muted-foreground">Client-level configuration.</p>
      </div>

      <Tabs defaultValue="general" className="flex flex-col gap-6">
        <TabsList>
          <TabsTrigger value="general">General</TabsTrigger>
          <TabsTrigger value="payables">Payables</TabsTrigger>
          <TabsTrigger value="receivables">Receivables</TabsTrigger>
          <TabsTrigger value="expenses">Expenses</TabsTrigger>
          {showWhatsApp && <TabsTrigger value="whatsapp">WhatsApp</TabsTrigger>}
        </TabsList>

        <TabsContent value="general" className="flex flex-col gap-6">
          <GeneralSettingsSection />
        </TabsContent>

        <TabsContent value="payables" className="flex flex-col gap-6">
          <PayablesSettingsSection />
          {activeClientId && <SpendCategoriesSection clientId={activeClientId} isAdmin={isAdmin} />}
        </TabsContent>

        <TabsContent value="receivables" className="flex flex-col gap-6">
          <ReceivablesSettingsSection />
        </TabsContent>

        <TabsContent value="expenses" className="flex flex-col gap-6">
          <ExpensesSettingsSection />
        </TabsContent>

        {showWhatsApp && (
          <TabsContent value="whatsapp" className="flex flex-col gap-6">
            <WhatsAppSettingsSection query={whatsApp} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
